import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78ede07c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "detail" }
const _hoisted_3 = { class: "detail-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "总人数", -1))
const _hoisted_5 = { class: "num" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "人", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-right" }, null, -1))
const _hoisted_8 = { class: "detail" }
const _hoisted_9 = { class: "detail-content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "当前在保", -1))
const _hoisted_11 = { class: "num" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "人", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-right" }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "detail"
}
const _hoisted_15 = { class: "detail-content" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("可替换名额 ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-info" }, null, -1))
const _hoisted_19 = { class: "replace-nums" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "num" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "1-3类", -1))
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "num" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "4类", -1))
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "num" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "5类", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-right" }, null, -1))
const _hoisted_30 = { class: "detail" }
const _hoisted_31 = { class: "detail-content" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "本月保费", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "doll" }, "¥", -1))
const _hoisted_34 = { class: "num" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.data?.person_count ?? 0), 1),
          _hoisted_6
        ])
      ]),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.data?.active_person_count ?? 0), 1),
          _hoisted_12
        ])
      ]),
      _hoisted_13
    ]),
    (_ctx.data.replace_info && _ctx.data.replace_info.level3+_ctx.data.replace_info.level4+_ctx.data.replace_info.level5 > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: "人数为加保日期为明天的情况，实际以加保确认界面为准",
                placement: "bottom"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.data.replace_info.level3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.data.replace_info.level3), 1),
                    _hoisted_22
                  ]))
                : _createCommentVNode("", true),
              (_ctx.data.replace_info.level4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.data.replace_info.level4), 1),
                    _hoisted_25
                  ]))
                : _createCommentVNode("", true),
              (_ctx.data.replace_info.level5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.data.replace_info.level5), 1),
                    _hoisted_28
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_29
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        _createElementVNode("div", null, [
          _hoisted_33,
          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.data?.current_month_premium ?? 0), 1)
        ])
      ]),
      _hoisted_35
    ])
  ]))
}